<!-- <link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" /> -->

<div class="container-fluid" my-5>
  <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;" class="page-header">
          <fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'list-check']"></fa-icon> Project Summary and Releases
        </h3>
      </div>

      <kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true"
        [groupable]="true" [resizable]="true"
        (sortChange)="sortChange($event)" style="height: calc(100vh - 200px); min-height: 400px;" [pageSize]="pageSize"
        [pageable]="true">

        <kendo-grid-column title="Summary" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button (click)="showSummary(dataItem)" kendoButton class="btn btn-stn-grid">
              <fa-icon icon="chart-column"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Releases" [width]="150">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <button (click)="showReleases(dataItem, windowTitleBar)" kendoButton class="btn btn-stn-grid">
                <fa-icon icon="code-merge"></fa-icon> {{dataItem.no_releases}}
              </button>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="project_name" title="Project" [width]="250">
          <!-- <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template> -->
        </kendo-grid-column>

        <kendo-grid-column field="no_stories_released" title="Released">
            
          </kendo-grid-column>

        <kendo-grid-column field="no_stories_accepted" title="Accepted">
           
        </kendo-grid-column>

        <kendo-grid-column field="no_stories_delivered" title="Delivered">
           
        </kendo-grid-column>

        <kendo-grid-column field="no_stories_finished" title="Finished">
            
        </kendo-grid-column>

        <kendo-grid-column field="no_stories_rejected" title="Rejected">
           
        </kendo-grid-column>

        <kendo-grid-column field="no_stories_started" title="Started">
            
        </kendo-grid-column>

        <kendo-grid-column field="no_unstarted" title="Not Started">
            
        </kendo-grid-column>

        <kendo-grid-column field="no_stories_unscheduled" title="Icebox">
            
        </kendo-grid-column>

        <kendo-grid-column field="no_deleted" title="Deleted">
            
        </kendo-grid-column>

        <ng-template kendoPagerTemplate>
          <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
        </ng-template>

      </kendo-grid>

    </div>
  </div>

</div>


<div kendoDialogContainer></div>


<div class="k-overlay" *ngIf="editWinOpen"></div>

<!-- <kendo-window *ngIf="editWinOpen" (close)="close()" [width]="1000">
  <kendo-window-titlebar>
    <span class="k-window-title"><fa-icon icon="code-merge"></fa-icon> Manage Releases For {{currentProject}} </span>
    <button kendoWindowCloseAction></button>
  </kendo-window-titlebar>
    <release-list [projectId]="currentProjectId" [project]="currentProject"></release-list>
</kendo-window> -->

<ng-template #windowTitleBar let-win>
  <span class="k-window-title">Manage Releases For {{currentProject}}</span>
  <button kendoWindowCloseAction [window]="win"></button>
</ng-template>

<div kendoWindowContainer></div>